<!--
 * @Author: cyl
 * @Date: 2022-09-02 15:34:45
 * @LastEditors: cyl
 * @LastEditTime: 2022-09-06 17:41:36
 * @Description: 
-->
<template>
  <div class="view-content">
    <div class="title">
      <div class="Imagbg-setting">
        <el-image :src="WechatTitleURL"></el-image>
      </div>
      <div class="title-context">请使用微信扫描二维码</div>
    </div>
    <div class="QR-wrapper">
      <div ref="qrCode"></div>
      <div v-show="maskInfo.isShow" class="mask">
        <icon-svg :iconClass="maskInfo.iconClass" :width="56" :height="56" />
        <!-- <icon-svg iconClass="amdox-warning" :width="56" :height="56" /> -->
        <div class="tip">{{ maskInfo.tip }}</div>
        <!-- <div class="tip">二维码已过期</div> -->
        <div
          v-show="maskInfo.hasRefresh"
          class="refreshQR"
          @click="refreshQRCode"
        >
          刷新二维码
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tempAddSmarkQrCode, QRLogin } from "@/api/login/login";
import QRCode from "qrcodejs2";
import { decryptBySecretIV } from "@/util/secretUtil";

export default {
  name: "QRLoin",
  mounted() {
    this.handlerTempAddSmarkQrCode();
    window.addEventListener("beforeunload", this.destroyedInterval);
  },
  destroyed() {
    this.destroyedInterval();
    window.removeEventListener("beforeunload", this.destroyedInterval);
  },
  data() {
    return {
      WechatTitleURL: require("@/assets/img/login/Sign_weixin_title.png"),
      setIntervalId: undefined,
      maskInfo: {
        isShow: false,
        state: undefined,
        tip: undefined,
        iconClass: "",
        hasRefresh: true, // 是否显示刷新
      },
    };
  },
  methods: {
    /**
     * @description: 刷新二维码
     * @return {*}
     */

    refreshQRCode() {
      this.setQRMaskState(false, undefined, undefined, undefined, true);
      this.destroyedInterval();
      this.handlerTempAddSmarkQrCode();
    },
    /**
     * @description: 生成二维码
     * @return {*}
     */
    createQRCode(QRContent) {
      this.$refs.qrCode.innerHTML = "";
      const qrCode = new QRCode(this.$refs.qrCode, {
        width: 216, // 宽度
        height: 216, // 高度
        text: QRContent, // 二维码内容
        render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.L, //容错级别 QRCode.CorrectLevel.L QRCode.CorrectLevel.M QRCode.CorrectLevel.Q QRCode.CorrectLevel.H
      });
      this.$refs.qrCode.title = "";
    },

    /**
     * @description: 微信扫码登录获取二维码信息
     * @return {*}
     */
    handlerTempAddSmarkQrCode() {
      this.$util.loading();
      tempAddSmarkQrCode()
        .then((res) => {
          if (res.data.state === "1") {
            const { data } = res.data;
            const QRContent = decryptBySecretIV(data.content, data.vipAra); // 解密
            this.queryUUID = data.uuid;
            this.createQRCode(QRContent);
            this.setIntervalId = window.setInterval(
              this.handlerSetInterval,
              2500
            );
          } else {
            this.$util.tips("warning", res.data.code);
          }
        })
        .catch((err) => {
          this.$util.tips("error", err);
        })
        .finally(() => {
          this.$util.loading(false);
        });
    },

    /**
     * @description: 定时器任务
     * @return {*}
     */
    handlerSetInterval() {
      if (!this.queryUUID) return;
      const params = { uuid: this.queryUUID };
      this.handlerLogin(params);
    },

    /**
     * @description: 销毁定时器
     * @return {*}
     */
    destroyedInterval() {
      if (this.setIntervalId) {
        clearInterval(this.setIntervalId);
        this.setIntervalId = undefined;
      }
    },

    /**
     * @description: 设置二维码mask信息
     * @return {*}
     */
    setQRMaskState(isShow, state, tip, iconClass, hasRefresh) {
      this.maskInfo.isShow = isShow;
      this.maskInfo.state = state;
      this.maskInfo.tip = tip;
      if (iconClass) {
        this.maskInfo.iconClass = `amdox-${iconClass}`;
        console.log("this.maskInfo.iconClass >>>> ", this.maskInfo.iconClass);
      } else {
        this.maskInfo.iconClass = "";
      }
      this.maskInfo.hasRefresh = hasRefresh;
    },

    /**
     * @description: 执行登录操作
     * @param {*} params
     * @return {*}
     */
    handlerLogin(params) {
      QRLogin(params)
        .then((res) => {
          const { data } = res.data;
          //二维码状态（成功 SUCCESS("1"), 失败 FAIL("2"), 未扫码 NO_QR_CODE("2001"),扫码 QR_CODE("2002"),取消 CANCEL("2003"), 二维码过期 TIME_OUT("2004"),用户不存在  NO_EXIST_USER("2005"), 用户未绑定 NO_BIND_USER("2006")）
          // const statCode = ['SUCCESS','NO_QR_CODE','TIME_OUT','NO_EXIST_USER','用户未绑定']
          // 未扫码
          if (res.data.state && res.data.state === "2001") {
            return;
          }
          // 扫码成功
          if (res.data.state && res.data.state === "2002") {
            this.setQRMaskState(true, 2002, "扫描成功", "success", false);
            return;
          }
          // 二维码过期
          if (res.data.state && res.data.state === "2004") {
            this.setQRMaskState(true, 2004, "二维码已过期", "warning", true);
            if (this.setIntervalId) {
              clearInterval(this.setIntervalId);
              this.setIntervalId = undefined;
            }
            return;
          }
          //取消
          if (res.data.state && res.data.state === "2003") {
            this.setQRMaskState(true, 2003, "已取消", "cancel", true);
            if (this.setIntervalId) {
              clearInterval(this.setIntervalId);
              this.setIntervalId = undefined;
            }
            return;
          }
          if (res.data.state && res.data.state === "1") {
            this.setQRMaskState(true, 1, "扫码成功", "success", false);
            if (this.setIntervalId) {
              clearInterval(this.setIntervalId);
              this.setIntervalId = undefined;
            }
            this.$util.loading();
            this.$store.commit("isLogin", true);
            //修改用户id
            this.$store.commit("setUserId", data.sessionUser.userId);
            //修改用户信息--------------------------------------------
            this.$store.commit("setUser", data.sessionUser);
            //把vuex保存在浏览器 防止用户刷新页面时vuex数据重置
            this.$util.setSess("store", JSON.stringify(this.$store.state));
            //保存token到sessionStorage
            this.$util.setSess("loginMessage", data.token);
            //将验证保存到sessionStorage
            this.$util.setSess("Authorazition", res.headers.authorazition);
            //是否记住登录状态
            if (this.$bus.loginChecked) {
              //保存1天
              this.$util.setCookie(
                "loginMessage",
                data.token,
                1 * 24 * 60 * 60 * 1000
              );
              this.$util.setCookie(
                "userId",
                data.sessionUser.userId,
                1 * 24 * 60 * 60 * 1000
              );
              this.$util.setCookie(
                "user",
                data.sessionUser,
                1 * 24 * 60 * 60 * 1000
              );
              this.$util.setCookie(
                "Authorazition",
                res.headers.authorazition,
                1 * 24 * 60 * 60 * 1000
              );
            } else {
              this.$util.clearCookie("loginMessage");
              this.$util.clearCookie("userId");
              this.$util.clearCookie("Authorazition");
            }

            this.$router.push({
              name: "ResourceCenter",
            });
          }
        })
        .catch((err) => {
          this.$util.loading(false);
          this.$util.tips("error", "请求失败");
          clearInterval(this.setIntervalId);
        })
        .finally(() => {
          this.$util.loading(false);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.view-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 49px 0;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    .title-context {
      font-size: 20px;
      color: #333333;
    }
  }
  .Imagbg-setting {
    margin-right: 10px;
    width: 32px;
    height: 32px;
  }
  .QR-wrapper {
    position: relative;
    display: inline-block;
    text-align: center;
    width: 216px;
    height: 216px;
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 216px;
      height: 216px;
      opacity: 0.96;
      background: #ffffff;
      .tip {
        font-size: 16px;
        text-align: center;
        color: #222222;
        margin-top: 10px;
        margin-bottom: 15px;
      }
      .refreshQR {
        font-size: 14px;
        text-align: center;
        color: #5384f8;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
